export enum WorkoutTypeEnum {
  BODYBUILDING = 'BODYBUILDING',
  ERGOMETER = 'ERGOMETER',
  STRETCHING = 'STRETCHING'
}
